module.exports = __webpack_public_path__ + "static/media/google.8b6871d2.jpeg";